const logError = (analytics, errorType, context = {}, originalError = null) => {
  try {
    if (!analytics || typeof analytics.logEvent !== 'function') {
      return '';
    }

    const errorEvent = {
      error_type: errorType,
      error_message: originalError?.message || context.error_message || 'Unknown error',
      timestamp: new Date().toISOString(),
      ...context,
    };

    analytics.logEvent('api_error', errorEvent);
    return '';
  } catch (analyticsError) {
    return analyticsError;
  }
};

export const log = async (error, vueInstance, methodName = null) => {
  try {
    const component = vueInstance?.$options?.name || 'UnknownComponent';

    let method = methodName || 'unknown_method';
    if (!methodName && error.stack) {
      const stackLines = error.stack.split('\n');
      for (let i = 2; i < Math.min(stackLines.length, 6); i += 1) {
        const line = stackLines[i] || '';
        const vueMatch = line.match(/at VueComponent\.(\w+)/);
        if (vueMatch) {
          method = vueMatch[1];
          break;
        }
      }
    }

    let apiEndpoint = null;
    if (error.message) {
      const apiMatch = error.message.match(/\/[\w/.-]+/);
      apiEndpoint = apiMatch?.[0];
    }

    const context = {
      component,
      method,
      ...(apiEndpoint && { api_endpoint: apiEndpoint }),
    };

    const errorType = `${method}_error`;

    logError(vueInstance?.$analytics, errorType, context, error);
    return '';
  } catch (logException) {
    return logException;
  }
};

export default { log };
